import { useMutation } from '@apollo/client';
import { CREATE_REPORT_MUTATION } from '../operations';

export const useCreateReport = () => {
  const [createReportMutation, { data, loading, error }] = useMutation(CREATE_REPORT_MUTATION);

  return {
    createReport: ({ reportTypeId, entityType, entityId, reportTemplate }) => {
      const entities = entityId && entityType ? [{ entityId, entityType }] : [];
      createReportMutation({
        variables: {
          input: {
            name: reportTemplate?.name || 'Untitled report',
            description: reportTemplate?.description || null,
            typeId: reportTypeId || 1,
            templateId: reportTemplate?.id || null,
            entities,
          },
        },
      });
    },
    data,
    loading,
    error,
  };
};
